export default __webpack_public_path__ + "static/media/logo-horiz.f6b9d1d9.png";